import {
  DefaultButton,
  Dropdown,
  PrimaryButton,
  Spinner,
  SpinnerSize,
} from 'office-ui-fabric-react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RichTextField } from '../../../components/RichTextField';
import { getLatestGlobalContentOfTypeInitialize } from '../../../features/actions/api';
import {
  getLatestGlobalContentByGlobalContentTypeId,
  isFetchingGlobalContentSelector,
} from '../../../features/apiFeatures/globalContentSlice';
import { allGlobalContentTypesSelector } from '../../../features/apiFeatures/globalContentTypeSlice';
import { getAttr } from '../../../features/helpers/apiHelpers';
import {
  isSavingContentSelector,
  saveChanges,
} from '../../../features/pageFeatures/globalContentAdministrationPageSlice';
import { noSelectionKey } from '../../../utilities/filterAndSortingsUtil';
import { optionsMapperWithNoSelection } from '../../../utilities/mapperFunctions';

const GlobalContentAdministrationPage = () => {
  const dispatch = useDispatch();
  const { t: translator } = useTranslation();

  const [
    selectedGlobalContentTypeKey,
    setSelectedGlobalContentTypeKey,
  ] = useState(noSelectionKey);
  const [localText, setLocalText] = useState('');

  const globalContentTypes = useSelector(allGlobalContentTypesSelector);
  const globalContent = useSelector(
    getLatestGlobalContentByGlobalContentTypeId(selectedGlobalContentTypeKey),
  );
  const isFetchingGlobalContent = useSelector(isFetchingGlobalContentSelector);
  const isSavingContent = useSelector(isSavingContentSelector);

  const onChangeDropDown = (_, value) => {
    setSelectedGlobalContentTypeKey(value.key);
    if (value.key === noSelectionKey) {
      return;
    }
    dispatch(getLatestGlobalContentOfTypeInitialize(value.key));
  };

  const globalContentText = getAttr(globalContent, 'content');

  useEffect(() => {
    setLocalText(globalContentText);
  }, [globalContentText]);

  const onCancelButton = () => {
    setLocalText('');
    setSelectedGlobalContentTypeKey(noSelectionKey);
  };

  const onSaveButton = () => {
    dispatch(
      saveChanges({
        globalContentTypeId: selectedGlobalContentTypeKey,
        content: localText,
      }),
    );
  };

  return (
    <div className="admin-page">
      <div className="admin-page-container">
        <div className="admin-page-container-header">
          <h2 className="Sfont p-style">
            {translator('pages.adminGlobalContents.header')}
          </h2>
        </div>
        <div className="administration-page-parent-column-stack">
          <div className="administration-page-parent-row-stack">
            <div className="administration-page-dropdown">
              <div className="admin-page-container-filters-specific">
                <Dropdown
                  label={translator('pages.adminGlobalContents.globalText')}
                  styles={dropdownStyles}
                  placeholder={translator('global.noneSelected')}
                  options={optionsMapperWithNoSelection(translator)(
                    globalContentTypes,
                  )}
                  onChange={onChangeDropDown}
                  selectedKey={selectedGlobalContentTypeKey}
                />
              </div>
            </div>
            {selectedGlobalContentTypeKey === noSelectionKey ? null : (
              <div className="administration-page-buttons">
                <DefaultButton
                  text={translator('global.cancel')}
                  iconProps={{ iconName: 'Cancel' }}
                  onClick={onCancelButton}
                  disabled={globalContentText === localText}
                />
                <PrimaryButton
                  text={translator('global.save')}
                  iconProps={{ iconName: 'Save' }}
                  onClick={onSaveButton}
                  disabled={globalContentText === localText || !localText}
                />
              </div>
            )}
          </div>
          {selectedGlobalContentTypeKey ===
          noSelectionKey ? null : isFetchingGlobalContent ? (
            <Spinner size={SpinnerSize.large} />
          ) : isSavingContent ? (
            <Spinner size={SpinnerSize.large} />
          ) : (
            <RichTextField
              initialValue={globalContentText}
              onChange={setLocalText}
              placeholder={''}
              expandTextField={true}
            />
          )}
        </div>
      </div>
    </div>
  );
};
export { GlobalContentAdministrationPage };

const dropdownStyles = {
  root: {
    width: '30%',
    minWidth: '300px',
    maxWidth: 425,
    height: 32,
  },
  dropdownOptionText: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};
